export var getBufferReader = function getBufferReader(response) {
  if (!response.body) {
    throw new Error('Response body is empty');
  }
  return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
export var addPath = function addPath(baseUrl, path) {
  var urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : "".concat(baseUrl, "/");
  var pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
  var url = [urlWithTrailingSlash, pathWithoutLeadingSlash].join('');
  return url;
};

/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */
var AiMateJiraXProduct = {
  JSM: 'JSM',
  JSW: 'JIRA-SOFTWARE',
  JWM: 'JIRA-CORE',
  JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */
var isJiraProduct = function isJiraProduct(product) {
  var JIRA_PRODUCTS = ['JPD', 'JSM', 'JSW', 'JWM'];
  return product !== undefined && JIRA_PRODUCTS.includes(product);
};

/**
 * Converts a `ProductType` to the expected `x-product` header value for AI Mate.
 *
 * @see https://developer.atlassian.com/platform/assistance-service/security/entitlements/#approach
 */
export var getXProductHeaderValue = function getXProductHeaderValue(product) {
  if (isJiraProduct(product)) {
    return AiMateJiraXProduct[product];
  }
  return product;
};